import { render, staticRenderFns } from "./MemberAddressConfigList.vue?vue&type=template&id=5c12516c&scoped=true&lang=pug&"
import script from "./MemberAddressConfigList.vue?vue&type=script&lang=ts&"
export * from "./MemberAddressConfigList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c12516c",
  null
  
)

export default component.exports